import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import Port from "../../../../../../domain/Port";
import PortFormItemProvider from "../PortFormItemProvider";

const fieldName = "Current Port";

const CurrentPortFormItemProvider: FormItemProvider<Port> = (props: FormItemProviderProps<Port>) => (
  <PortFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="CurrentPort"
  />
);

export default React.memo(CurrentPortFormItemProvider);
